import * as es from 'date-fns/locale/es';
import * as en from 'date-fns/locale/en';

export const locales: any = {
  es,
  en,
}